module.exports = __webpack_public_path__ + "img/converter-icon.977fc97e.png";